<template>
  <div>
    <div class="week-fast-news-list-detail-date">
      <div class="row date-content">
        <div class="date-content-month">{{month}}月</div>
        <div class="date-content-day">{{day}}</div>
        <div></div>
      </div>
    </div>
    <transition-group name="list">
      <week-fast-news-list-item class="week-fast-news-list-detail-item" v-for="(item) in list" :key="item.newsId" :data="item"></week-fast-news-list-item>
    </transition-group>
  </div>
</template>

<script>
import WeekFastNewsListItem from '@/components/recommend/WeekFastNewsListItem';


export default {
  props: {
    date: {
      type: String
    },
    data: {
      type: Object
    },
    list: {
      type: Array
    },
    latestNewsData: {
      type: Array
    }
  },
  computed: {
    month() {
      return /(\d{1,2})-(\d{1,2})/g.exec(this.date)[1];
    },
    day() {
      return /(\d{1,2})-(\d{1,2})/g.exec(this.date)[2];
    }
  },
  components: {
    WeekFastNewsListItem
  }
};
</script>

<style lang="scss" scoped>
  .week-fast-news-list-detail-date {
    position: relative;
    width: 100%;
    height: 25px;
    border-left: solid 2px #f7f7fa;
    .date-content {
      position: absolute;
      top: 8px;
      left: -16px;
      height: 17px;
      line-height: 15px;
      width: 64px;
      border: 1px solid #45a8cc;
      border-radius: 2px;
      font-size: 12px;
      .date-content-month {
        width: 36px;
        text-align: center;
        color: #464d6c;
        background-color: #ffffff;
      }
      .date-content-day {
        position: absolute;
        right: -1px;
        top: -1px;
        height: 17px;
        line-height: 17px;
        width: 29px;
        text-align: center;
        color: #ffffff;
        border-top-right-radius: 2px;
        border-bottom-right-radius: 2px;
        background-color: #45a8cc;
      }
    }
  }
  .week-fast-news-list-detail-item {
    background-color: #ffffff;
  }
  .list-move {
    transition: all 1s;
    display: inline-block;
  }
  .list-enter, .list-leave-to
  /* .list-leave-active for below version 2.1.8 */ {
    opacity: 0;
  }
</style>

